import SEO from "../../components/SEO";


import useCurrentPage from "../../hooks/useCurrentPage";

// style document been use in this page
import { useGlobalContext } from "../../hooks/useGlobalContext";
import CardImage from "../../components/Layout/Cards/CardImage";



const WorkPage = (props) => {
  const { handlePage } = props;

  const globalContext = useGlobalContext();
  const workPageContent = globalContext.content.personal_projects;

  // pass current Page
  useCurrentPage(handlePage);

  // Drafted projects stay out of every channel, same rule as blog posts.
  const cards = workPageContent.showcase_Data
    .filter((project_Data) => project_Data.draft !== true)
    .map((project_Data, index) => {
      return (<CardImage key={project_Data.id} data={project_Data} externalLink={project_Data.project_url.startsWith('http')} />);
    });

  const pageContent = (
    <div className="page-content">
      <SEO
        title={workPageContent.helmet_Title}
        description="A collection of my personal projects and experiments."
        url="https://estebanlasso.com/personal_projects"
      />
      <br />
      <h1 hidden>Personal Projects</h1>
      <br />
      <div className="cards-container">
        <div className="cards-wrapper">
          {cards}
        </div>
      </div>

    </div>
  );

  return pageContent;
};
export default WorkPage;
